import DemographicsForm from './DemographicsForm'
import ModalComponent from '../common/Modal/Modal.component'
import React from 'react'
import customerStore from '../../datastore/CustomerStore'
import { observer } from 'mobx-react'
import styled from '@emotion/styled'
import { upsertPreLeadObject } from '../../service/preLeadService'

interface ContactDetailsModalProps {
  onClose: () => void
  emailOnly?: boolean
}

const FormWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  align-items: stretch;
`

const ContactDetailsModal: React.FC<ContactDetailsModalProps> = ({
  onClose,
  emailOnly = false,
}) => {
  const needsEmail = !customerStore.email
  // Only ask for phone once email has been provided, and not in emailOnly contexts
  const needsPhone = !emailOnly && !!customerStore.email && !customerStore.phone

  // Nothing missing — auto-dismiss
  React.useEffect(() => {
    if (!needsEmail && !needsPhone) onClose()
  }, [])

  const handleCancel = () => onClose()

  const handleFormSuccess = () => {
    upsertPreLeadObject({
      ...(needsEmail && customerStore.email
        ? { email: customerStore.email }
        : {}),
      ...(needsPhone && customerStore.phone
        ? { phone: customerStore.phone }
        : {}),
    })
    onClose()
  }

  return (
    <ModalComponent
      setOpen={handleCancel}
      width={480}
      description='Add contact details'
      zIndex={10000}
    >
      <FormWrapper>
        <DemographicsForm
          contactOnly
          showEmail={needsEmail}
          showPhone={needsPhone}
          heading='Stay connected'
          submitLabel='Save'
          cancelLabel='Not Now'
          onSuccess={handleFormSuccess}
          onCancel={handleCancel}
          submitId={
            needsEmail ? 'saveStayConnectedEmail' : 'saveStayConnectedPhone'
          }
        />
      </FormWrapper>
    </ModalComponent>
  )
}

export default observer(ContactDetailsModal)
